import { api } from "../lib";

export interface SignaturePresignedUrlResponse {
  url: string;
  key: string;
}

export const signatureService = {
  getPresignedUrl: async (
    fileName: string,
    contentType: string
  ): Promise<SignaturePresignedUrlResponse> => {
    return api.post<SignaturePresignedUrlResponse>(
      "/documents/presigned-url/user-signatures",
      { fileName, contentType }
    );
  },

  uploadToS3: async (url: string, file: Blob): Promise<void> => {
    await fetch(url, {
      method: "PUT",
      body: file,
      headers: { "Content-Type": file.type || "image/png" },
    });
  },

  updateMySignature: async (
    signatureImageUrl: string
  ): Promise<{ success: boolean; signatureImageUrl: string }> => {
    return api.put<{ success: boolean; signatureImageUrl: string }>(
      "/users/me/signature",
      { signatureImageUrl }
    );
  },

  removeMySignature: async (): Promise<{ success: boolean }> => {
    return api.delete<{ success: boolean }>("/users/me/signature");
  },
};
